(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('zetasrealtime', {
            parent: 'entity',
            url: '/zetasrealtime?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.zetasrealtime.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/zetasrealtime/zetasrealtimes.html',
                    controller: 'ZetasrealtimeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('zetasrealtime');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('zetasrealtime-detail', {
            parent: 'zetasrealtime',
            url: '/zetasrealtime/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.zetasrealtime.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/zetasrealtime/zetasrealtime-detail.html',
                    controller: 'ZetasrealtimeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('zetasrealtime');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Zetasrealtime', function($stateParams, Zetasrealtime) {
                    return Zetasrealtime.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'zetasrealtime',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('zetasrealtime-detail.edit', {
            parent: 'zetasrealtime-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zetasrealtime/zetasrealtime-dialog.html',
                    controller: 'ZetasrealtimeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Zetasrealtime', function(Zetasrealtime) {
                            return Zetasrealtime.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('zetasrealtime.new', {
            parent: 'zetasrealtime',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zetasrealtime/zetasrealtime-dialog.html',
                    controller: 'ZetasrealtimeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fechaproceso: null,
                                comercio: null,
                                ip: null,
                                pv: null,
                                nroz: null,
                                fechadesde: null,
                                fechahasta: null,
                                zetamontoventas: null,
                                zetamontoncredito: null,
                                ticketsmontoventas: null,
                                ticketsmontoncredito: null,
                                ticketscantventas: null,
                                ticketscantncredito: null,
                                itemscantventas: null,
                                itemscantncredito: null,
                                nivelproceso: null,
                                fechaoperativa: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('zetasrealtime', null, { reload: 'zetasrealtime' });
                }, function() {
                    $state.go('zetasrealtime');
                });
            }]
        })
        .state('zetasrealtime.edit', {
            parent: 'zetasrealtime',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zetasrealtime/zetasrealtime-dialog.html',
                    controller: 'ZetasrealtimeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Zetasrealtime', function(Zetasrealtime) {
                            return Zetasrealtime.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('zetasrealtime', null, { reload: 'zetasrealtime' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('zetasrealtime.delete', {
            parent: 'zetasrealtime',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zetasrealtime/zetasrealtime-delete-dialog.html',
                    controller: 'ZetasrealtimeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Zetasrealtime', function(Zetasrealtime) {
                            return Zetasrealtime.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('zetasrealtime', null, { reload: 'zetasrealtime' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
